import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../ReduxToolkit/Store';
import BusinessDash from './BusinessDash';

/* BUSINESS - the broking businesses that buy the Business Builder. */
const BuilderDashboard: React.FC = () => {
    const { RoleID } = useSelector((state: RootState) => state.adminAuth);
    const isAdmin = Number(RoleID) === 1 || RoleID == null;

    if (!isAdmin) {
        return <div style={{ padding: 24 }}>The dashboard is not available for this account.</div>;
    }
    return <BusinessDash which='managed' title='Business' />;
};

export default BuilderDashboard;
